import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import TextBoxWithLabel from './TextBoxWithLabel';
import TextBoxWithoutDP from './TextBoxWithoutDP';
import SliderWithLabel from './SliderWithLabel';
import SliderWithLabelSmart from './SliderWithLabelSmart';
import SelectBoxWithLabel from './SelectBoxWithLabel';
import support from '../images/support-icon.png';
import InfoPopup from './InfoPopup';
import useIsSmartphone from './useIsSmartphone';
import useIsTablet from './useIsTablet';
import InfoPopupSmart from './InfoPopupSmart';
import TextBoxWithLabelSmart from './TextBoxWithLabelSmart';
import TextBoxWithoutDPSmart from './TextBoxWithoutDPSmart';
import InfoPopupAdded from './InfoPopupAdded';
import InfoPopupAdded2 from './InfoPopupAdded2';

const CoefficientText = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  font-family: Arial, sans-serif;
`;

const Container = styled.div`
  @media (max-width: 768px) {
    background-color: ${props => props.bgColor || 'white'};
    
    box-sizing: border-box;
    padding: 10px;
  }
  @media (min-width: 769px) {
    background-color: ${props => props.bgColor || 'white'};
    
    box-sizing: border-box;
    padding: 20px;
  }
`;

const StyledText = styled.div`
  @media (min-width: 769px) {
    font-family: Arial, sans-serif;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2rem;
    color: #9A9A9A;
  }

  @media (max-width: 768px) {
    font-family: Arial, sans-serif;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2rem;
    color: #9A9A9A;

  }
`;

const StyledImage = styled.img`
  @media (min-width: 769px) {
    width: 80px;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 60px;
    height: auto;
  }
`;

const DynamicWidthDiv = styled.div`
  width: calc(72% + 50px);
`;

const C1Calc = ({ bgColor, 
  setSLf1Dia, setSLf1Surface,
  setSLf2Dia, setSLf2Surface,
  setSLf3Dia, setSLf3Surface
 }) => {
  const { t, i18n  } = useTranslation();
  const locale = i18n.language;

  const isSmartphone = useIsSmartphone();
  const isTablet = useIsTablet();

  const formatNumberForLocale = (number, locale) => {
    return new Intl.NumberFormat(locale, {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 20,
    }).format(number);
  };
  
  const [mass, setMass] = useState('');
  const [suctionCupCount, setSuctionCupCount] = useState('');
  const [acceleration, setAcceleration] = useState('');
  const [vacuum, setVacuum] = useState(() => formatNumberForLocale(0.6, locale));
  const [safetyFactor, setSafetyFactor] = useState('2');

  const [cmass, setCMass] = useState('');
  const [cvacuum, setCVacuum] = useState('0.6');
  const [cacceleration, setCAcceleration] = useState('');
  const [csafetyFactor, setCSafetyFactor] = useState('2');

  const [selectedMassUnit, setSelectedMassUnit] = useState('kg');
  const [selectedAccnUnit, setSelectedAccnUnit] = useState('ms2');
  const [selectedPresUnit, setSelectedPresUnit] = useState('bar');
  const [coeff, setCoeff] = useState(0.5);
  const [fcoeff, setFCoeff] = useState(0.5);
  const [ghcoeff, setGhcoeff] = useState(0.5);

  const [rmass, setRMass] = useState(0.0);
  const [racceleration, setRAcceleration] = useState(0.0);
  const [rvacuum, setRVacuum] = useState(0.0);
  const [rsuctionCupCount, setRSuctionCupCount] = useState(0);
  const [rsafetyFactor, setRSafetyFactor] = useState(0);

  const [targetWidthDP, setTargetWidthDP] = useState(0);
  const [targetWidthTB, setTargetWidthTB] = useState(0);
  const [targetWidthText, setTargetWidthText] = useState(0);

  const [winwid, setWinwid] = useState(0);
  const winwidRef = useRef(winwid);

  useEffect(() => {
    winwidRef.current = winwid;
    //console.log('winwiddd:', winwid);
  }, [winwid]);

  const massUnitOptions = [
    { value: 'kg', label: 'kg' },
    { value: 'g', label: 'g' },
    { value: 'lbs', label: 'lbs' },
    { value: 'oz', label: 'oz' },
  ];

  const accnUnitOptions = [
    { value: 'ms2', label: 'm/s²' },
    { value: 'fts2', label: 'ft/s²' },
  ]

  const presUnitOptions = [
    { value: 'bar', label: 'bar' },
    { value: 'mbar', label: 'mbar' },
    { value: 'kpa', label: 'kPa' },
    { value: 'inhg', label: 'inHg' },
    { value: 'inh2o', label: 'inH²O' },
    { value: 'psi', label: 'psi' },
  ]

  useEffect(() => {
    if (vacuum.trim() !== '') setVacuum(formatNumberForLocale(parseFloat(vacuum.replace(',', '.')), locale));
    if (mass.trim() !== '') setMass(formatNumberForLocale(parseFloat(mass.replace(',', '.')), locale));
    if (acceleration.trim() !== '') setAcceleration(formatNumberForLocale(parseFloat(acceleration.replace(',', '.')), locale));
    if (safetyFactor.trim() !== '') setSafetyFactor(formatNumberForLocale(parseFloat(safetyFactor.replace(',', '.')), locale));
  }, [locale]);

  const numberFormatter = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  });

  const parseNumber = (value) => {
    const example = numberFormatter.format(1.1);
    const cleanedValue = value.replace(new RegExp(`[^0-9${example.charAt(1)}]`, 'g'), '')
                              .replace(example.charAt(1), '.');
    return parseFloat(cleanedValue);
  };

  const handleVacuumChange = (value) => {
    const parsedValue = parseNumber(value);
    setCVacuum(parsedValue.toFixed(2));
    setVacuum(value);
  };

  const handleMassChange = (value) => {
    const parsedValue = parseNumber(value);
    setCMass(parsedValue.toFixed(2));
    setMass(value);
  };

  const handleAccnChange = (value) => {
    const parsedValue = parseNumber(value);
    setCAcceleration(parsedValue.toFixed(2));
    setAcceleration(value);
  };

  const handleSafetyFactorChange = (value) => {
    const parsedValue = parseNumber(value);
    setCSafetyFactor(parsedValue.toFixed(2));
    setSafetyFactor(value);
  };

  const calcRmass = () => {
    switch (selectedMassUnit) {
      case 'kg':
        setRMass(parseFloat(cmass));
        break;
      case 'g':
        setRMass(parseFloat(cmass) * 0.001);
        break;
      case 'lbs':
        setRMass(parseFloat(cmass) * 0.453514739);
        break;
      case 'oz':
        setRMass(parseFloat(cmass) * 0.0283495);
        break;
    }
  }

  const calcRaccn = () => {
    switch (selectedAccnUnit) {
      case 'ms2':
        setRAcceleration(parseFloat(cacceleration));
        break;
      case 'fts2':
        setRAcceleration(parseFloat(cacceleration) * 0.3048);
        break;
    }
  }

  const calcRvacuum = () => {
    switch (selectedPresUnit) {
      case 'bar':
        setRVacuum(parseFloat(cvacuum));
        break;
      case 'mbar':
        setRVacuum(parseFloat(cvacuum) * 0.001);
        break;
      case 'kpa':
        setRVacuum(parseFloat(cvacuum) * 0.01);
        break;
      case 'inhg':
        setRVacuum(parseFloat(cvacuum) * 0.033863867);
        break;
      case 'inh2o':
        setRVacuum(parseFloat(cvacuum) * 0.002488429);
        break;
      case 'psi':
        setRVacuum(parseFloat(cvacuum) * 0.068946498);
        break;
    }
  }

  // **************************

  useEffect(() => {
    if (mass.trim() !== '') {
      calcRmass();
    }
  }, [mass]);

  useEffect(() => {
    if (mass.trim() !== '') {
      calcRmass();
    }
  }, [selectedMassUnit]);

  useEffect(() => {
    if (acceleration.trim() !== '') {
      calcRaccn();
    }
  }, [acceleration]);

  useEffect(() => {
    if (acceleration.trim() !== '') {
      calcRaccn();
    }
  }, [selectedAccnUnit]);

  useEffect(() => {
    if (vacuum.trim() !== '') {
      calcRvacuum();
    }
  }, [vacuum]);

  useEffect(() => {
    if (vacuum.trim() !== '') {
      calcRvacuum();
    }
  }, [selectedPresUnit]);

  useEffect(() => {
    if (suctionCupCount.trim() !== '') {
      setRSuctionCupCount(parseInt(suctionCupCount, 10));
    }
  }, [suctionCupCount]);

  useEffect(() => {
    if (safetyFactor.trim() !== '') {
      setRSafetyFactor(parseFloat(csafetyFactor));
    }
  }, [safetyFactor]);

  // ***************************

  useEffect(() => {
    /*
    console.log('rmass:', rmass);
    console.log('rsafetyFactor:', rsafetyFactor);
    console.log('racceleration:', racceleration);
    console.log('rvacuum:', rvacuum);
    console.log('rsuctionCupCount:', rsuctionCupCount);
    console.log('fcoeff:', fcoeff);
    console.log('mass:', mass);
    */
    if ((mass.trim() === '')
        || (safetyFactor.trim() === '')
        || (acceleration.trim() === '')
        || (vacuum.trim() === '')
        || (suctionCupCount.trim() === '')
        || (parseFloat(rvacuum) === 0)
        || (parseInt(rsuctionCupCount) === 0)) {
          setSLf1Dia('-');
          setSLf2Dia('-');
          setSLf3Dia('-');
          setSLf1Surface('-');
          setSLf2Surface('-');
          setSLf3Surface('-');
        } else {

          const dd1 = 1.12 * Math.sqrt((rmass * 10 * rsafetyFactor * (9.81 + racceleration))
                                      / (rvacuum * rsuctionCupCount));
          const ad1 = dd1.toFixed(2);
          setSLf1Dia(formatNumberForLocale(parseFloat((ad1).replace(',', '.')), locale));

          const ss1 = (3.141592654 * (1.12 * (Math.sqrt((rmass * 10 * rsafetyFactor * (9.81 + racceleration)) / (rvacuum * rsuctionCupCount))))
                      * (1.12 * (Math.sqrt((rmass * 10 * rsafetyFactor * (9.81 + racceleration)) / (rvacuum * rsuctionCupCount))))) / 4;
          const bd1 = ss1.toFixed(2);
          setSLf1Surface(formatNumberForLocale(parseFloat((bd1).replace(',', '.')), locale));

          const dd2 = 1.12 * (Math.sqrt(((rmass * 10) * rsafetyFactor * (9.81 + racceleration / fcoeff)) / (rvacuum * rsuctionCupCount)));
          const ad2 = dd2.toFixed(2);
          setSLf2Dia(formatNumberForLocale(parseFloat((ad2).replace(',', '.')), locale));

          const ss2 = (3.141592654 * (1.12 * (Math.sqrt(((rmass * 10) * rsafetyFactor * (9.81 + racceleration / fcoeff)) / (rvacuum * rsuctionCupCount))))
                      * (1.12 * (Math.sqrt(((rmass * 10) * rsafetyFactor * (9.81 + racceleration / fcoeff)) / (rvacuum * rsuctionCupCount))))) / 4;
          const bd2 = ss2.toFixed(2);
          setSLf2Surface(formatNumberForLocale(parseFloat((bd2).replace(',', '.')), locale));

          const dd3 = 1.12 * Math.sqrt((rmass * 10 * rsafetyFactor * (9.81 + racceleration)) / (rvacuum * rsuctionCupCount * fcoeff));
          const ad3 = dd3.toFixed(2);
          setSLf3Dia(formatNumberForLocale(parseFloat((ad3).replace(',', '.')), locale));

          const ss3 = (3.141592654 * (1.12 * Math.sqrt((rmass * 10 * rsafetyFactor * (9.81 + racceleration)) / (rvacuum * rsuctionCupCount * fcoeff)))
                      * (1.12 * Math.sqrt((rmass * 10 * rsafetyFactor * (9.81 + racceleration)) / (rvacuum * rsuctionCupCount * fcoeff)))) / 4;
          const bd3 = ss3.toFixed(2);
          setSLf3Surface(formatNumberForLocale(parseFloat((bd3).replace(',', '.')), locale));
        }

  }, [rmass, rsafetyFactor, racceleration, rvacuum, rsuctionCupCount, fcoeff,
    mass, safetyFactor, acceleration, vacuum, suctionCupCount]);

  // ***************************

  const handleMassUnitChange = (selectedOption) => {
    setSelectedMassUnit(selectedOption.value);
  };

  const handleAccnUnitChange = (selectedOption) => {
    setSelectedAccnUnit(selectedOption.value);
  };

  const handlePresUnitChange = (selectedOption) => {
    setSelectedPresUnit(selectedOption.value);
  };
/*
  const handleSliderChange = (newValue) => {
    const snapPositions = Array.from({ length: 5 }, (_, i) => i / 4); // 5 equally spaced positions between 0 and 1
    const nearestSnap = snapPositions.reduce((prev, curr) =>
      Math.abs(curr - newValue.target.value) < Math.abs(prev - newValue.target.value) ? curr : prev
    );
    let kk = (1 - nearestSnap);
    if (kk === 0) { kk= 0.1; }
    else if ((kk > 0.2) && (kk <= 0.3)) { kk = 0.2; }
    else if ((kk > 0.7) && (kk <= 0.8)) { kk = 0.7; }
    setFCoeff(kk);
  };
*/
  const handleSliderChange = (event) => {
    const newValue = parseFloat(event.target.value); // Get the value from the event
    const snapPositions = Array.from({ length: 5 }, (_, i) => i / 4); // 5 equally spaced positions between 0 and 1
    const nearestSnap = snapPositions.reduce((prev, curr) =>
      Math.abs(curr - newValue) < Math.abs(prev - newValue) ? curr : prev
    );

    // Determine the snapped value for fcoeff
    let snappedValue = 1 - nearestSnap;
    if (snappedValue === 0) {
      snappedValue = 0.1;
    } else if (snappedValue > 0.2 && snappedValue <= 0.3) {
      snappedValue = 0.2;
    } else if (snappedValue > 0.7 && snappedValue <= 0.8) {
      snappedValue = 0.7;
    }

    let ghVal = nearestSnap;
    if (ghVal === 0) {
      ghVal = 0;
    } else if (ghVal > 0.2 && ghVal <= 0.3) {
      ghVal = 0.2;
    } else if (ghVal > 0.7 && ghVal <= 0.8) {
      ghVal = 0.7;
    }
    setGhcoeff(nearestSnap);
    setFCoeff(snappedValue);
  };

  /*
  useEffect(() => {
    console.log('ghcoeff:', ghcoeff);
  }, [ghcoeff]);
  */

  useEffect(() => {
    const updateTargetWidth = () => {
    
      setTargetWidthDP(window.innerWidth * 0.84 - 0);
      setTargetWidthTB(window.innerWidth * 0.84 - 65);

      /*
      if (window.innerWidth > 1230) {
        setTargetWidthDP(800);
      } else {
        setTargetWidthDP(window.innerWidth * 0.84)
      }
*/

      setTargetWidthTB(window.innerWidth * 0.84 - 65);

      //let k1 = window.innerWidth * 0.32;
      
      let k1;
      if (window.innerWidth > 1230) {
        k1 = 600;
      } else if (window.innerWidth > 868 && window.innerWidth <= 1229) {
        k1 = window.innerWidth * 0.32 + 160;
      } else {
        k1 = window.innerWidth * 0.32 + 140;
      }
      
      setTargetWidthText(k1);

      const newWidth = window.innerWidth;
      setWinwid(newWidth);

    };

    updateTargetWidth(); // Initial calculation

    // Recalculate on window resize
    window.addEventListener('resize', updateTargetWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateTargetWidth);
    };
  }, []);

  let m1Left;
  if (isSmartphone) { m1Left = '3.5%'; }
  else if (isTablet) { m1Left = '5.2%'; }
  else { m1Left = '25px'; }

  let pc1;
  let pc2;
  let pc3;
  let pc4;
  let pc5;
  //if (isSmartphone) { pc1 = 2.2; pc2 = 26.4; pc3 = 50.7; pc4 = 74.8; pc5 = 99; }
  //else { pc1 = 1.05; pc2 = 25.6; pc3 = 50.4; pc4 = 75; pc5 = 99.7; }
  if (winwid < 415) { pc1 = 2.3; pc2 = 26.5; pc3 = 50.5; pc4 = 74.8; pc5 = 99; }
  else if ((winwid >= 415) && (winwid < 500)) { pc1 = 1.8; pc2 = 26.4; pc3 = 50.7; pc4 = 74.8; pc5 = 99; }
  else if ((winwid >= 500) && (winwid < 560)) { pc1 = 1.6; pc2 = 26.1; pc3 = 50.7; pc4 = 74.8; pc5 = 99; }
  else if ((winwid >= 560) && (winwid < 650)) { pc1 = 1.4; pc2 = 26; pc3 = 50.4; pc4 = 74.8; pc5 = 99.4; }
  else { pc1 = 1.2; pc2 = 25.7; pc3 = 50.3; pc4 = 74.9; pc5 = 99.5; } 


  return (
    <Container style={{ width: '100%' }} bgColor={bgColor}>
      <div style={{ marginTop: '15px', marginLeft: m1Left, textAlign: 'left' }}>

        {((isSmartphone === false) && (isTablet === false)) && (
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <TextBoxWithLabel 
              label= {t('Mass of the workpiece') + ':'} 
              unit="" 
              value={mass} 
              onChange={handleMassChange} 
            />
            <div style={{ marginLeft: '35px' }}>
              <SelectBoxWithLabel 
                label={t('Unit') + ':'} 
                options={massUnitOptions} 
                onChange={handleMassUnitChange}
                value={selectedMassUnit}
              />
            </div>
          </div>
        )}

        {((isSmartphone === true) || (isTablet === true)) && (
          <div style={{ display: 'flex', width: targetWidthTB }}>
            <div style={{ flexGrow: 1, marginRight: '0px' }}>
              <TextBoxWithLabelSmart
                label={t('Mass of the workpiece') + ':'}
                unit=""
                value={mass}
                onChange={handleMassChange}
              />
            </div>
            <div style={{ width: '35px', marginLeft: '30px' }}>
              <SelectBoxWithLabel
                label={t('Unit') + ':'}
                options={massUnitOptions}
                onChange={handleMassUnitChange}
                value={selectedMassUnit}
              />
            </div>
          </div>
        )}

        {((isSmartphone === false) && (isTablet === false)) && (
          <div style={{ display: 'flex', marginTop: '20px' }}>
            <TextBoxWithoutDP 
              label={t('Number of suction cups') + ':'} 
              value={suctionCupCount} 
              onChange={setSuctionCupCount} 
            />
          </div>
        )}

        {((isSmartphone === true) || (isTablet === true)) && (
          <div style={{ marginTop: '20px' }}>
            <div style={{ width: targetWidthDP }}>
              <TextBoxWithoutDPSmart 
                label={t('Number of suction cups') + ':'} 
                value={suctionCupCount} 
                onChange={setSuctionCupCount} 
              />
            </div>
          </div>
        )}


        {((isSmartphone === false) && (isTablet === false)) && (
          <div style={{ display: 'flex', marginTop: '5px' }}>
            <div style={{ marginLeft: '3px' }}>
            <SliderWithLabel 
              type="range" 
              label={t('Friction coefficient') + ':'} 
              min={0} 
              max={1} 
              step={0.25} 
              thickness="1px" 
              color="#9A9A9A" 
              thumbColor="#005b99" 
              value={ghcoeff} 
              onChange={handleSliderChange} 
              width={targetWidthDP}
              winwid={winwid}
            />
              {/*<p>Current coeff: {fcoeff}</p>*/}
            </div>

            <div style={{ marginTop: '10px', marginLeft: '-28px' }}>
              <InfoPopupAdded2 distanceFactor={winwid} />
            </div>

          </div>
        )}

        {(isSmartphone || isTablet) && (
          <div>

            <div style={{ display: 'flex', justifyContent: 'space-between', width: '88vw', marginTop: '15px' }}>
              <CoefficientText>
                {t('Friction coefficient') + ':'}
              </CoefficientText>
              <div>
                <InfoPopupSmart distanceFactor={winwid} />
              </div>
            </div>



            <div style={{ marginTop: '52px', fontFamily: 'Arial, sans-serif', fontSize: '1.4rem', fontWeight: '400' }}>
              <SliderWithLabelSmart
                min={0}
                max={1}
                step={0.25}
                thickness="1px"
                color="#9a9a9a"
                thumbColor="#005b99"
                value={ghcoeff}
                onChange={handleSliderChange}
                sliderWidth="91%"  // Custom width for the slider
                leftMargin="0px"
                tickOffsets={[pc1, pc2, pc3, pc4, pc5]}   // Hardcoded positions for ticks as percentages
                legendOffsets={[1, 23, 50, 75, 97]} // Hardcoded positions for legends as percentages
                valueOffsets={[3, 26, 51, 75, 98]}
              />
              {/*<p>Current coeff: {fcoeff}</p>*/}
            </div>
          </div>
        )}

        {((isSmartphone === false) && (isTablet === false)) && (
          <div style={{ display: 'flex', marginTop: '50px' }}>
            <TextBoxWithLabel 
              label= {t('Acceleration') + ':'} 
              unit="" 
              value={acceleration} 
              onChange={handleAccnChange} 
            />
            <div style={{ marginLeft: '35px' }}>
              <SelectBoxWithLabel 
                label={t('Unit') + ':'} 
                options={accnUnitOptions} 
                onChange={handleAccnUnitChange}
                value={selectedAccnUnit}
              />
            </div>
          </div>
        )}

        {((isSmartphone === true) || (isTablet === true)) && (
          <div style={{ display: 'flex', marginTop: '60px', width: targetWidthTB }}>
            <div style={{ flexGrow: 1, marginRight: '0px' }}>
              <TextBoxWithLabelSmart
                label={t('Acceleration') + ':'}
                unit=""
                value={acceleration}
                onChange={handleAccnChange}
              />
            </div>
            <div style={{ width: '35px', marginLeft: '30px' }}>
              <SelectBoxWithLabel
                label={t('Unit') + ':'}
                options={accnUnitOptions}
                onChange={handleAccnUnitChange}
                value={selectedAccnUnit}
              />
            </div>
          </div>
        )}

        {((isSmartphone === false) && (isTablet === false)) && (
          <div style={{ display: 'flex', marginTop: '20px' }}>
            <TextBoxWithLabel 
              label= {t('Negative pressure') + ':'} 
              unit="" 
              value={vacuum} 
              onChange={handleVacuumChange} 
            />
            <div style={{ marginLeft: '35px' }}>
              <SelectBoxWithLabel 
                label={t('Unit') + ':'} 
                options={presUnitOptions} 
                onChange={handlePresUnitChange}
                value={selectedPresUnit}
              />
            </div>
          </div>
        )}

        {((isSmartphone === true) || (isTablet === true)) && (
          <div style={{ display: 'flex', marginTop: '20px', width: targetWidthTB }}>
            <div style={{ flexGrow: 1 }}>
              <TextBoxWithLabelSmart
                label={t('Negative pressure') + ':'}
                unit=""
                value={vacuum}
                onChange={handleVacuumChange}
              />
            </div>
            <div style={{ width: '35px', marginLeft: '30px' }}>
              <SelectBoxWithLabel
                label={t('Unit') + ':'}
                options={presUnitOptions}
                onChange={handlePresUnitChange}
                value={selectedPresUnit}
              />
            </div>
          </div>
        )}

        {((isSmartphone === false) && (isTablet === false)) && (
          <div style={{ display: 'flex', marginTop: '20px' }}>
            <TextBoxWithLabel 
              label={t('Safety factor') + ':'} 
              value={safetyFactor} 
              onChange={handleSafetyFactorChange} 
            />
          </div>
        )}

        {((isSmartphone === true) || (isTablet === true)) && (
          <div style={{ marginTop: '20px' }}>
            <div style={{ width: targetWidthDP }}>
              <TextBoxWithLabelSmart 
                label={t('Safety factor') + ':'} 
                value={safetyFactor} 
                onChange={handleSafetyFactorChange} 
              />
            </div>
          </div>
        )}


        {((isSmartphone === false) && (isTablet === false)) && (
          <div style={{ display: 'flex', marginTop: '15px', width: targetWidthText }}>
            <StyledText>
              <p>
                {t('Our internal sales department provides comprehensive support in the planning and calculation of your application')}
              </p>
              <p>
                {t('If you have any questions or other concerns, please do not hesitate to contact us.')}
              </p>
            </StyledText>
            {/*
            <div style={{ marginLeft: '5vw', marginTop: '15px' }}>
              <StyledImage src={support} alt='lastfall1' />
            </div>
            */}
          </div>
        )}

        {((isSmartphone === true) || (isTablet === true)) && (
          <div style={{ display: 'flex', marginTop: '15px',
            width: targetWidthDP, justifyContent: 'space-between' }}>
          <StyledText style={{ width: targetWidthDP }}>
            <p>
              {t('Our internal sales department provides comprehensive support in the planning and calculation of your application')}
            </p>
            <p>
              {t('If you have any questions or other concerns, please do not hesitate to contact us.')}
            </p>
          </StyledText>
          {/*
          <div style={{ marginLeft: '20px', marginTop: '15px' }}>
            <StyledImage src={support} alt='lastfall1' />
          </div>
          */}
        </div>
      )}

      </div>
    </Container>
  );
};

export default C1Calc;
